export default __webpack_public_path__ + "static/media/potion.a16a4c0c.gif";